import type { CarrierLogoProps } from './types'
import LogoSvg from '../../assets/carrier-logos/fedex-logo.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const FedExLogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function FedExLogo(props, ref) {
    const logoProps = getLogoProps(props, {
      primary: { light: '#472f92', dark: '#ffffff' },
    })

    return <Logo {...logoProps} ref={ref} />
  },
)
